'use strict';
const angular = require('angular');

module.exports = angular
    .module('spinnaker.core.task.monitor.error', [])
    .component('taskMonitorError', {
      bindings: {
        monitor: '=',
      },
      template: `<div class="col-md-12 overlay-modal-error" ng-if="$ctrl.monitor.error">
        <alert type="danger">
          <h4><i class="fa fa-exclamation-triangle"></i> Error:</h4>

          <p ng-bind-html="$ctrl.monitor.errorMessage"></p>
        </alert>
        <p ng-if="$ctrl.monitor.task.id">
          <a
            ui-sref="home.applications.application.tasks.taskDetails({application: $ctrl.monitor.application.name, taskId: $ctrl.monitor.task.id})">
            View this failed task in the tasks pane.
          </a>
        </p>
      </div>`
    });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/task/monitor/taskMonitorError.component.js